import { ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Dependencies } from '../../../../store';
import { PayloadAction } from '../../../../store.model';
import { SocketService } from '../../../../teams-call';
import { ActionType } from '../teamschat-dialog.action';

import { UpdateChat, updateChatResult } from './update-chat.action';

export const updateChatEpic = (
    action: Observable<PayloadAction<ActionType, UpdateChat>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<PayloadAction<ActionType, UpdateChat> | null> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TCD__UPDATE_CHAT),
        mergeMap((act: PayloadAction<ActionType, UpdateChat>) => {
            const socketService =
                deps.injector.get<SocketService>(SocketService);

            return of(null).pipe(
                tap(() => {
                    void socketService.updateChat(act.payload.chat);
                }),
                map(() => {
                    return updateChatResult(
                        {
                            ...act.payload,
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
